module.exports = __webpack_public_path__ + "img/auth_bg.2b0602b4.jpg";